import React, {useRef, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import {updateMailingMethod, checkIsKosherOrAflaloNumber, saveToHistory, setCurrentMethod, setDwhParams} from './UpdateMailingMethodSlice';
import {MailingMethod, InputValidation, NumberValidationStatus} from './Constant';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import Checkbox from '../../Shared/CheckBox/Checkbox';
import TextInput from '../../Shared/TextInput/TextInput';
import _ from 'lodash';
import { dwhMailingMethod } from './dwhReport';
import { gaMailingPageContinueButton,gaInvoiceMailingPage } from './gaReports';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import Config from '../../../Config';
import ThirdParty from '../../Shared/ThirdParty/ThirdParty';


function UpdateMailingMethod(props) {
  const [input, setInput] = useState("");
  const [error, setError] = useState("");
  const phoneRef = useRef();
  const emailRef = useRef();
  const [isPrimaryEmail, setIsPrimaryEmail] = useState(false);
  const [colLabCheck, setColLabCheck] = useState(props.colLabIsApproved); //indicate if collaboration approval is check
  const [showMailCheckBox, setShowMailCheckBox] = useState(false);

  useEffect(() => {
    gaInvoiceMailingPage();
    props.setDwhParams({
      ...props.dwhParams,
      actionType: "Choosing mailing method",
    });
    createDwhReport("Choosing mailing method screen displayed");
  }, []);

  const validateInput = (inputVal) => {
    setInput(inputVal);
    let inputValidation = InputValidation[getCurrentMethod()];
    let regex = new RegExp(inputValidation.regexPattern);
    var match = regex.test(String(inputVal).toLowerCase());
    if(!showMailCheckBox && props.currentMethod == MailingMethod.Mail){
      checkPrimaryEmail(inputVal)
    }
    if (!match) {
      inputVal == ""
        ? setError(inputValidation.error.emptyInput)
        : setError(inputValidation.error.invalidInput);
        return false;
    } else {
      setError("");
       return true;
    }
  };


  let getCurrentMethod = () => {
    return _.findKey(MailingMethod, (method) => method === props.currentMethod);
  };

  const updateMailingMethod = async (btnText) => {
   if(validateInput(input)){
      if(props.currentMethod == MailingMethod.Phone)
        {
          var res = await props.checkIsKosherOrAflaloNumber(input);
            if(res.payload.Body.body.response.status != NumberValidationStatus.OPEN) {
              return;
            }
        }
        gaMailingPageContinueButton(
          props.currentMethod,
          isPrimaryEmail,
          btnText,
        );

        createDwhReport("Choosing mailing method button clicked");
        await props.updateMailingMethod({
          newMethod: getCurrentMethod(),
          mailingDest: input,
          ban: [...props.selectedBan].join(";"),
          isPrimaryEmail: isPrimaryEmail,
          CollaborationApproval: colLabCheck,
        });
      }
  }

  const checkPrimaryEmail = (value) => {
    let regex = new RegExp(InputValidation.Mail.regexPattern);
    var match = regex.test(String(value).toLowerCase());
    props.primaryMail !== value && match
      ? setShowMailCheckBox(true)
      : setShowMailCheckBox(false);
  };

  const createDwhReport = (message) => {
    dwhMailingMethod({
      ...props.dwhParams,
      status: "Ongoing",
      message,
      ban: props.selectedBan.join(";"),
      param3: props.currentMethod,
    });
  };

  return (
    <div>
      <div className="header">
        <p className="title">{props.content.mainTitleUpdatePage.value}</p>
        <p className="bold-text">{props.content.secondaryTitleUpdatePage.value}</p>

        <div className="mailing_nav_bar swiper-tabs">
          {Object.keys(MailingMethod).map((key) => (
            <div
              key={key}
              className={`swiper-item ${
                props.currentMethod == MailingMethod[key] && "active"
              }`}
              onClick={() => {
                props.setCurrentMethod(MailingMethod[key]);
                setError("");
                setInput("");
              }}
            >
              {MailingMethod[key]}
            </div>
          ))}
        </div>
      </div>

      <div className="mailingInputContainer">
        <div className="address-wrapper">
          <div className="form-wrapper">
            {props.currentMethod == MailingMethod.Mail && (
              <>
                <div className="row-wrapper">
                  <TextInput
                    value={input}
                    error={error}
                    id="mail"
                    name="mail"
                    placeholder='דוא"ל'
                    onChange={(e) => validateInput(e.target.value)}
                    ref={emailRef}
                  />
                </div>
                {showMailCheckBox && (
                  <Checkbox
                    id="primary-email-checkbox"
                    onCheck={() => {
                      setIsPrimaryEmail(true);
                      createDwhReport("Mail checkbox clicked");
                    }}
                    onUncheck={() => setIsPrimaryEmail(false)}
                    checked={isPrimaryEmail}
                    label={<div className='checkbox-text'>{Config.primaryEmailText} <a href='#' className='link' onClick={() => prepareUrl(Config.primaryEmailMoreInfoUrl,EpiContext)}>{Config.primaryEmailMoreInfoText}</a></div>}
                  />
                )}
              </>
            )}
            {props.currentMethod == MailingMethod.Phone && (
              <div className="row-wrapper">
                <TextInput
                  value={input}
                  error={error}
                  id="phone"
                  name="phone"
                  placeholder="מספר טלפון"
                  onChange={(e) => validateInput(e.target.value)}
                  ref={phoneRef}
                />
              </div>
            )}
            {!props.colLabIsApproved && (
              <Checkbox
                id="collaboration-checkbox"
                onCheck={() => {
                  setColLabCheck(true);
                  createDwhReport("Agreements checkbox clicked");
                }}
                onUncheck={() => setColLabCheck(false)}
                checked={colLabCheck}
                label = {<ThirdParty />}
              />
            )}
          </div>
        </div>
        <div className="btn-container">
          <BtnSubmit
            text="המשך"
            onclick={(e) => {
              updateMailingMethod(e.currentTarget.textContent);
            }}
          />
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  currentMailingDest: state.updateMailingMethod.currentMailingDest,
  colLabIsApproved: state.updateMailingMethod.colLabIsApproved,
  selectedBan: state.updateMailingMethod.selectedBan,
  primaryMail: state.updateMailingMethod.primaryMail,
  currentMethod: state.updateMailingMethod.currentMethod,
  dwhParams: state.updateMailingMethod.dwhParams,
});
const mapDispatchToProps = {
  updateMailingMethod,
  checkIsKosherOrAflaloNumber,
  saveToHistory,
  setCurrentMethod,
  setDwhParams,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateMailingMethod);
